import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";

export function getIdealForEverybodyWebApps(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "E-shopy a online platformy",
			desc: `V [${getEcommercePath(tenant)}][[e-commerce]] jsou webové aplikace sp[[alfou a omegou.]] Vytvoříme pro vás například e-shop na míru.`,
		},
		{
			title: "Interní a podnikové systémy",
			desc: `Podnikáte v odvětví HORECA či logistice a potřebujete vlastní podnikový systém? sp[[Postaráme se o to.]]`,
		},
		{
			title: "Startupy a technologické firmy",
			desc: "Řada začínajících firem z oblasti technologií se bez vlastní webové aplikace sp[[neobejde.]]",
		},
		{
			title: "Služby a zákaznická podpora",
			desc: `Webové aplikace sp[[dodáváme]] i firmám působícím v odvětví služeb nebo třeba HR sektoru.`,
		},
	];
}
